import '../gettext'
import type { GatewayConfig } from './declarations'
import DataBasinLogo from '../../images/logo-databasin.svg?file'
import HeaderLogo from '../components/Header/HeaderLogo.svelte'
import Navigation from '../components/Header/Navigation.svelte'
import Header from '../components/Header'
import ShowcaseIcon from 'images/icon-ribbon.png'
import ArticleIcon from 'images/icon-article.png'
import GalleryIcon from 'images/icon-gallery.png'
import MapIcon from 'images/icon-map.png'
import DatasetIcon from 'images/icon-dataset.png'
import GroupIcon from 'images/icon-group.png'
import DatasetDefinitionIcon from 'images/icon-dataset-definition.png'
import PersonIcon from 'images/icon-person.png'
import TeamIcon from 'images/icon-team.png'
import EventsIcon from 'images/icon-events.png'
import Favicon from 'images/icon-favicon.svg?file'

declare global {
  interface Window {
    sampleMapURL?: string
  }
}
const sampleMapURL = window.sampleMapURL?.trim() || null

export default {
  gateway: null,
  title: 'Data Basin',
  logo: DataBasinLogo,
  logoComponent: HeaderLogo,
  navigationComponent: Navigation,
  headerComponent: Header,
  navigation: user => [
    {
      id: 'get-started',
      label: window.gettext('Get Started'),
      items: [
        {
          type: 'text',
          text: window.gettext(
            'Data Basin is a science-based mapping and analysis platform that supports learning, research, and sustainable environmental stewardship.',
          ),
          label: 'More about Data Basin...',
          href: '/about/',
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('View Video Tutorials'),
          href: '/videos/',
        },
        {
          type: 'link',
          label: window.gettext('Search Geographies or Keywords'),
          href: '/search/',
        },
        sampleMapURL && {
          type: 'link',
          label: window.gettext('Explore a Sample Map'),
          href: sampleMapURL,
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('FAQs'),
          href: '/help/',
          bold: true,
        },
        {
          type: 'link',
          label: window.gettext('Support Services'),
          href: '/services/services/',
          bold: true,
        },
        {
          type: 'link',
          label: window.gettext('Glossary'),
          href: '/glossary/',
          bold: true,
        },
        {
          type: 'link',
          label: window.gettext('Newsletter Archive'),
          href: 'https://consbio.org/news/#:~:text=Data%20Basin%20Monthly%20Newsletters',
          bold: true,
        },
      ],
    },

    {
      id: 'explore',
      label: window.gettext('Explore'),
      items: [
        {
          type: 'link',
          label: window.gettext('Showcase'),
          image: ShowcaseIcon,
          href: '/showcase/',
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('Use Cases'),
          image: ArticleIcon,
          href: '/articles/',
        },
        {
          type: 'link',
          label: window.gettext('Galleries'),
          image: GalleryIcon,
          href: '/galleries/',
        },
        {
          type: 'link',
          label: window.gettext('Maps'),
          image: MapIcon,
          href: '/maps/',
        },
        {
          type: 'link',
          label: window.gettext('Datasets'),
          image: DatasetIcon,
          href: '/datasets/',
        },
      ],
    },
    {
      id: 'create',
      label: window.gettext('Create'),
      width: '245px',
      items: [
        {
          type: 'link',
          label: window.gettext('Create a Map'),
          image: MapIcon,
          href: '/maps/new/',
        },
        {
          type: 'link',
          label: window.gettext('Import a Dataset'),
          image: DatasetIcon,
          href: '/datasets/import/',
        },
        {
          type: 'link',
          label: window.gettext('Create a Group'),
          image: GroupIcon,
          href: '/groups/new/',
        },
        {
          type: 'link',
          label: window.gettext('Create a Gallery'),
          image: GalleryIcon,
          href: '/galleries/new/',
        },
        (user?.isContentAdmin || user?.isGatewayAdmin) && {
          type: 'link',
          label: window.gettext('Create a Use Case'),
          image: ArticleIcon,
          href: '/articles/new/',
        },
        user?.canCreateDefinition && {
          type: 'link',
          label: window.gettext('Create a Dataset Definition'),
          image: DatasetDefinitionIcon,
          href: '/datasets/definition/new/',
        },
      ],
    },
    {
      id: 'community',
      label: window.gettext('Community'),
      width: '215px',
      items: [
        {
          type: 'heading',
          label: `${window.gettext('Meet')}...`,
        },
        {
          type: 'link',
          label: window.gettext('Members'),
          image: PersonIcon,
          href: '/people/',
        },
        {
          type: 'link',
          label: window.gettext('Groups'),
          image: GroupIcon,
          href: '/groups/',
        },
        {
          type: 'link',
          label: window.gettext('Data Basin Team'),
          image: TeamIcon,
          href: '/people/databasin-team/',
        },
        {
          type: 'heading',
          label: `${window.gettext('Join in')}...`,
        },
        {
          type: 'link',
          label: window.gettext('Events'),
          image: EventsIcon,
          href: '/events/',
        },
        {
          type: 'link',
          label: window.gettext('Donate'),
          image: Favicon,
          href: '/making_difference/',
        },
      ],
    },
  ],
  footer: [
    {
      label: window.gettext('About'),
      href: '/about/',
    },
    {
      label: window.gettext('Terms of Use'),
      href: '/pages/terms-service/',
    },
    {
      label: window.gettext('Support Services'),
      href: '/services/services/',
    },
    {
      label: window.gettext('Contact Us'),
      href: '/services/contact/',
    },
    {
      label: window.gettext('Donate'),
      href: '/making_difference/',
    },
  ],
  pages: {
    home: () => import('../pages/Home'),
    servers: () => import('../pages/Admin/Servers/ServersPage.svelte'),
  },
  share: false,
} as GatewayConfig
